import { cls } from "cls";
import React from "react";

interface ItemProps {
  children: React.ReactNode;
  listItemProps?: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLLIElement>,
    HTMLLIElement
  >;
  isOverflowing?: boolean;
  itemWidth?: string;
}

const Item = ({
  children,
  listItemProps,
  itemWidth,
  isOverflowing,
}: ItemProps) => {
  return (
    <li
      {...listItemProps}
      className={cls(
        "group flex flex-col flex-shrink-0 list-none relative transform origin-center scale-100 scroll-snap-align-start",
        listItemProps?.className,
        isOverflowing && "last:border-r-transparent",
        itemWidth,
      )}
      data-testid="Carousel Item"
    >
      {children}
    </li>
  );
};

export default Item;
